import ImageHelper from "../../Helpers/ImageHelper";

const PortfolioDataWeb = [
  {
    title: "TEZ Tiger NFT",
    caption: "NFT Collectibles Website",
    image: ImageHelper.Web1,
    fullWebSS: true,
  },
  {
    title: "TZ Creation",
    caption: "Company Website",
    image: ImageHelper.Web2,
    fullWebSS: true,
  },
  {
    title: "The Zaika",
    caption: "Restaurant Website",
    image: ImageHelper.Web3,
    fullWebSS: true,
  },
  {
    title: "Gro House",
    caption: "Business Website",
    image: ImageHelper.Web10,
    fullWebSS: true,
  },
  {
    title: "Kafi Coffee",
    caption: "Brand Website",
    image: ImageHelper.Web11,
    fullWebSS: true,
  },
  {
    title: "Fooddi Gar",
    caption: "Business Website",
    image: ImageHelper.Web12,
    fullWebSS: true,
  },
  {
    title: "CAAR",
    caption: "Business Website",
    image: ImageHelper.Web13,
    fullWebSS: true,
  },
  {
    title: "Trainer X",
    caption: "Business Website",
    image: ImageHelper.Web14,
    fullWebSS: true,
  },
  {
    title: "FinStake",
    caption: "Product Website",
    image: ImageHelper.Web15,
    fullWebSS: true,
  },
  {
    title: "Reine Beauty Studio",
    caption: "Business Website",
    image: ImageHelper.Web16,
    fullWebSS: true,
  },
  {
    title: "Vecna",
    caption: "Business Website",
    image: ImageHelper.Web17,
    fullWebSS: true,
  },
  {
    title: "Reine Barber Shop",
    caption: "Business Website",
    image: ImageHelper.Web18,
    fullWebSS: true,
  },
  {
    title: "Kayelux Beauty Salon",
    caption: "Business Website",
    image: ImageHelper.Web19,
    fullWebSS: true,
  },
  {
    title: "Accounting",
    caption: "Serivces Website",
    image: ImageHelper.Web20,
    fullWebSS: true,
  },
  {
    title: "EduLearn",
    caption: "Institute Website",
    image: ImageHelper.Web21,
    fullWebSS: true,
  },
  {
    title: "Bidroid Auctoin App",
    caption: "App Landing Page",
    image: ImageHelper.Web4,
    fullWebSS: true,
  },
  {
    title: "IndieSports",
    caption: "College Project",
    image: ImageHelper.Web5,
    fullWebSS: true,
  },
  {
    title: "BDRG",
    caption: "E-Commerce Website",
    image: ImageHelper.Web6,
    fullWebSS: true,
  },
  {
    title: "Bridge Honey",
    caption: "Product Website",
    image: ImageHelper.Web7,
    fullWebSS: true,
  },
  {
    title: "Coffee Shop",
    caption: "Startup Website",
    image: ImageHelper.Web8,
    fullWebSS: true,
  },
  {
    title: "Bridge Ice-Cream Shop",
    caption: "Business Website",
    image: ImageHelper.Web9,
    fullWebSS: true,
  },
];

export default PortfolioDataWeb;
